var Index_banner_swiper = new Swiper(".Index_testimonials_slider", {
    spaceBetween: 20,
    speed: 1000,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});